import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

/**
 * Wraps any /dashboard/* route except the login page. Redirects to
 * /login when no session is active, preserving the originally-requested
 * path via router state so post-login lands on the intended page.
 *
 * One identity for everyone (2026-05-23) — access to a specific
 * dashboard screen is enforced server-side by the permission layer;
 * this route only checks that the user is signed in.
 */
export function PrivateDashboardRoute({ children }: { readonly children: ReactNode }): JSX.Element {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-text-secondary">
        Loading…
      </div>
    )
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />
  }
  return <>{children}</>
}
